
export const TimeIcon = () => {
  return (
    <div className="contacts__icon">
      <svg
        width="35"
        height="35"
        viewBox="0 0 35 35"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.5 0C7.835 0 0 7.835 0 17.5C0 27.1649 7.835 34.9999 17.5 34.9999C27.1649 34.9999 34.9999 27.1649 34.9999 17.5C34.9897 7.83933 27.1607 0.0103271 17.5 0ZM17.5 32.5C9.21569 32.5 2.49997 25.7842 2.49997 17.5C2.49997 9.21569 9.21569 2.49997 17.5 2.49997C25.7842 2.49997 32.5 9.21569 32.5 17.5C32.491 25.7806 25.7806 32.491 17.5 32.5Z"
          fill="white"
        />
        <path
          d="M17.5 6.25C16.8096 6.25 16.25 6.80964 16.25 7.50002V16.25H7.50002C6.80964 16.25 6.25 16.8097 6.25 17.5001C6.25 18.1904 6.80964 18.75 7.50002 18.75H17.5C18.1904 18.75 18.75 18.1904 18.75 17.5V7.50002C18.75 6.80964 18.1904 6.25 17.5 6.25Z"
          fill="white"
        />
      </svg>
    </div>
  )
}
